export default "__VITE_ASSET__e18ca933__"